import { FC, useCallback, useState } from 'react';

import { IoMdClose } from 'react-icons/io';
import { FaCheckDouble } from 'react-icons/fa';

import { useTheme } from 'styled-components';

import { useMediaQuery } from '~/common/hooks/use-media-query';
import { Typography } from '~/common/components/Typograph';
import { Modal } from '~/common/components/Modal';
import { Button } from '~/common/components/Button';

import { Footer, PromptApprovalModalContainer } from './styles';

interface IPromptApprovalModalProps {
  action: 'approve' | 'unapprove';
  open: boolean;
  close: () => void;
  confirm: () => Promise<void>;
}

export const PromptApprovalModal: FC<IPromptApprovalModalProps> = ({
  action,
  open,
  close,
  confirm,
}) => {
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width: 750px)');

  const handleConfirm = useCallback(async () => {
    setLoading(true);
    confirm().finally(() => {
      setLoading(false);
    });
  }, [confirm]);

  return (
    <Modal
      isOpen={open}
      title="Confirmação"
      onClose={close}
      id="confirm-prompt-approval-modal"
      width="750px"
      height={isMobile ? '200px' : 'auto'}
    >
      <PromptApprovalModalContainer>
        <Typography.Label size="large" color="neutral0">
          {action === 'approve'
            ? 'Você tem certeza que deseja aprovar este prompt?'
            : 'Você tem certeza que deseja desaprovar este prompt?'}
        </Typography.Label>

        <Footer>
          <Button
            text="Cancelar"
            onClick={close}
            width="100%"
            backgroundColor={theme.neutral950}
            borderColor={theme.red}
            textOrIconColor={theme.red}
            justifyContent="center"
          />
          <Button
            width="100%"
            icon={action === 'approve' ? FaCheckDouble : IoMdClose}
            text={action === 'approve' ? 'Aprovar' : 'Desaprovar'}
            onClick={handleConfirm}
            justifyContent="center"
            loading={loading}
            loader="bar"
          />
        </Footer>
      </PromptApprovalModalContainer>
    </Modal>
  );
};
